// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hv-0";